import './scss/style.scss'

export default {
   name: 'SlideReferencias',
   created() {
      this.itemService = this.items
   },

   data() {
      return {
         form: {
            pagina: 1,
            limite: 1,
            ordenar: 'nome'
         },
         selectedItem: null,
         filteredItems: null
      }
   },
   itemService: null,

   props: {
      items: null,
      possuiPaginaAnterior: null,
      possuiProximaPagina: null,
      loading: null
   },

   methods: {
      searchCountry(event) {
         this.filteredCountriesBasic = this.itemService.search(event.query)
      },

      proximo() {
         if (this.possuiProximaPagina) {
            this.$emit('proximo')
         }
      },

      anterior() {
         if (this.possuiPaginaAnterior) {
            this.$emit('anterior')
         }
      }
   }
}
